import {
  Component, OnInit, Input, Output, EventEmitter,
} from "@angular/core";
import {CostCenterModel} from "./cost-center.model";

@Component({
  selector: "cost-centers-list",
  templateUrl: "./cost-centers-list.template.pug",
})
export class CostCentersListComponent implements OnInit {
  public showNewCostCenter: boolean = false;
  public newCostCenter: string = "";
  public costCenterSelected: any;
  public showErrorNewCostCenter: boolean = false;
  @Input() public costCenters: CostCenterModel[];
  @Input() public costCenterIdFromDB: string = "";
  @Input() public allowEdit: boolean = true;
  @Output() public costCenterSelectedEvent: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

  public updateNewCostCenterVisibility(show) {
    this.showNewCostCenter = show;
    this.showErrorNewCostCenter = false;
    this.newCostCenter = "";
  }

  isValidNewCostCenter(): boolean {
    if (this.newCostCenter.trim() === "" ||
      this.costCenters.some(element => element.name === this.newCostCenter.trim()) ||
      this.newCostCenter.trim().length > 150
    ) {
      return false;
    }
    return true;
  }

  public saveNewCostCenter() {
    if (this.isValidNewCostCenter()) {
      const newCostCenter = {
        costCenterId: "",
        name: this.newCostCenter,
      };
      this.costCenters.push(newCostCenter);
      this.newCostCenter = "";
      this.showNewCostCenter = false;
      this.costCenterSelected = newCostCenter.name;
      this.emitCostCenterSelected();
      this.showErrorNewCostCenter = false;
    } else {
      this.showErrorNewCostCenter = true;
    }
  }

  public emitCostCenterSelected() {
    const selectedCostCenter = this.costCenters.find(elem => elem.name === this.costCenterSelected);
    this.costCenterSelectedEvent.emit(selectedCostCenter);
  }

  ngOnInit() {
    const selectedCostCenterIndex = this.costCenters
      .findIndex(element => element.costCenterId === this.costCenterIdFromDB);

    if (selectedCostCenterIndex >= 0) {
      this.costCenterSelected = this.costCenters[selectedCostCenterIndex].name;
    }
  }
}
